import cibilReport from "./assets/Modern CIBIL Credit Dashboard Workspace.png"
import smartCombo from "./assets/image9.png"
import secureCombo from "./assets/image11.png"
import esign from "./assets/image1.png"
import estamp from "./assets/image10.png"
import transparent from "./assets/image3.png"
import instant from "./assets/Collaborative Loan Processing Workflow.png"
import bankLevel from "./assets/Futuristic Fintech Security Shield.png"
import trusted from "./assets/Collaborative DSA Team Growth Dashboard.png"

export const services = [
  {
    title: "Detailed CIBIL Report",
    subtitle: "₹200 + GST",
    description: [
        "Complete credit report",
        "Downloadable PDF format",
        "Soft check with zero score impact",
        "Helps understand loan readiness before applying and identifying credit improvement areas",
    ],
    image: cibilReport
},
    {
        title: "Basic CAM Note",
        subtitle: "₹500 + GST",
        description: ["CIBIL report included", "Pre-approval support from 3+ leading banks", "Fast, online, and paperless process", "Budget-friendly service option"],
        image: smartCombo
    },
    {
        title: "Standard CAM Note",
        subtitle: "₹1000 + GST",
        description: ["CIBIL report included", "Pre-approval support from 3+ leading banks", "Fast, online, and paperless process", "30-day money-back guarantee"],
        image: secureCombo
    },
    {
        title: "E-Sign",
        subtitle: "₹50 + GST",
        description: ["Execute agreements remotely", "Upload unsigned documents", "Download signed PDF instantly"],
        image: esign
    },
    {
        title: "E-Stamps",
        subtitle: "Stamp duty + ₹100 convenience fee + GST",
        description: ["No need to search stamp vendors", "Execute legal documents faster", "Designed for regular business use"],
        image: estamp
    },
]


export const details = [
    {
        title: "Instant, paperless loan workflows",
        image: instant,
        description: "Digital lead creation, document movement, and service execution reduce repeated manual work so teams can move from enquiry to action faster."
    },
    {
        title: "Trusted by growing DSA teams",
        image: trusted,
        description: "The platform is designed for real field execution, helping DSAs manage customers, follow-ups, services, and income opportunities with confidence."
    },
    {
        title: "Bank-level security for sensitive data",
        image: bankLevel,
        description: "Customer profiles, financial documents, and operational records stay organized inside a more secure system built for lending workflows."
    },
    {
        title: "Transparent pricing with no hidden charges",
        image: transparent,
        description: "Customers and DSAs can move ahead with clear pricing, visible service value, and no surprise costs hidden inside the process."
    },
]


export const appLinks = {
  sales: {
    name: "Sales App",
    audience: "For Sales Team",
    title: "Download the MyRinBazaar Sales App",
    description: "Manage leads, track loan files and collaborate with bankers on the go.",
    playStore: "https://play.google.com/store/apps/details?id=com.ns.ksdpl",
    appStore: "https://apps.apple.com/in/app/ksdpl/id6758232819",
  },
  banker: {
    name: "Banker App",
    audience: "For Bankers",
    title: "Download the MyRinBazaar Banker App",
    description: "Receive loan files, review applications and respond to DSAs faster.",
    playStore: "https://play.google.com/store/apps/details?id=com.dp.ksdpl_bankerapp",
    appStore: "https://apps.apple.com/us/app/myrinbazaar-banker/id6761003904",
  },
  customer: {
    name: "Customer App",
    audience: "For Customers",
    title: "Download the MyRinBazaar Customer App",
    description: "Track your loan application, upload documents and stay updated at every step.",
    playStore: "https://play.google.com/store/apps/details?id=com.dp.ksdpl_customer",
    appStore: "https://apps.apple.com/us/app/ksdpl-customer/id6759285045",
  },
}
